import css from 'styled-jsx/css';

const styles = css`@import "./styles/global-variables";

.banner-container{
    width: 100%;
}`;

export default styles;